function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("style", null, ".twitter-logo_svg__st0{fill:#303030}");

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "twitter-logo_svg__st0",
  d: "M14.5 20.2L5.9 30H1.1l11.1-12.7zM17.1 11l7.8-9h4.8L19.3 13.9z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "twitter-logo_svg__st0",
  d: "M31.5 30h-9.6L.5 2h9.8l21.2 28zm-8.3-2.8h2.6L8.9 4.7H6.1l17.1 22.5z"
});

var SvgTwitterLogo = function SvgTwitterLogo(props) {
  return React.createElement("svg", _extends({
    id: "twitter-logo_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI4LjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAzMiAzMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzIgMzI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojMzAzMDMwO30KPC9zdHlsZT4KPGc+Cgk8cG9seWdvbiBjbGFzcz0ic3QwIiBwb2ludHM9IjE0LjUsMjAuMiA1LjksMzAgMS4xLDMwIDEyLjIsMTcuMyAJIi8+Cgk8cG9seWdvbiBjbGFzcz0ic3QwIiBwb2ludHM9IjE3LjEsMTEgMjQuOSwyIDI5LjcsMiAxOS4zLDEzLjkgCSIvPgoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTMxLjUsMzBoLTkuNkwwLjUsMmg5LjhMMzEuNSwzMHogTTIzLjIsMjcuMmgyLjZMOC45LDQuN0g2LjFMMjMuMiwyNy4yTDIzLjIsMjcuMnoiLz4KPC9nPgo8L3N2Zz4K";
export { SvgTwitterLogo as ReactComponent };